
<router-outlet ></router-outlet>

